import { Service, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";
import { filter, interval, map } from "rxjs";

@Service()
export class HorrorService {
	username!: string;
	password!: string;
	token!: string;
  private cherishAuthorized = false;

	constructor() {
	}

	public setCredentials(
		username: string,
		password: string
	) {
		this.username = username;
		this.password = password;
	}

	public authenticateUser(): boolean {
		let isAuthenticated = false;

		switch (this.username) {
			case "saeki_kayako0408":
				isAuthenticated = true;
				break;
			default:
				break;
		}

		return isAuthenticated;
	}

  setCherishAuthorized(value: boolean) {
    this.cherishAuthorized = value;
  }

  isCherishAuthorized(): boolean {
    return this.cherishAuthorized;
  }

  clearCherishAuthorized() {
    this.cherishAuthorized = false;
  }
}
